import { Injectable } from '@angular/core';
import { SCIPConfiguration } from '@scip/api';

@Injectable({
  providedIn: 'root'
})
export class ScipConfigurationService extends SCIPConfiguration {}
